import CompanyService from "../../service/CompanyService";
import router from "../../router";
import store from "../store";
// import this.$swal from 'sweetalert'

//export const namespaced = true

export const state = {
    companies:[],
    accounts:[],
    accountsAdmin:[],
    company:[],
    account:[],
    isCompaniesUpt: false,
    isAccountsUpt: false,
    isAccountsAdminUpt: false,
    companiesLoading: false,
    accountsLoading: false,
    createCompanyLoading:false,
    createAccountLoading:false,
    acc:'',
    response:{}

}


export const getters = {
    accountName: state => {
        let account =  state.company[0].accounts.filter(function (el) {
            return el.accNumber === localStorage.accNumber;
        })[0];
        if (account == null)
            return ''
        else
            return account.accName
    }
}


export const mutations = {
    updateCompanies: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.companies = payload
    },
    updateCompany: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.company = state.companies.filter(function (el) {
            return el.orgID === payload;
        });
        console.log('Entered Mutation cc', payload);
    },
    updateAccounts: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.accounts = payload
    },
    updateAcc: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.acc = payload
    },
    updateAccount: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.account = state.company[0].accounts.filter(function (el) {
            return el.accNumber === payload;
        });
        console.log('Entered Mutation', state.account[0]);
        localStorage.accID = state.account[0].accID
    },
    updateAccountsAdmin: (state, payload) =>{
        // console.log('Entered Mutation', payload);
        state.accountsAdmin = payload
    },
    updateIsCompaniesUpt: (state, payload) =>{
    // console.log('Entered Mutation', payload);
        state.isCompaniesUpt = payload;
    },
    updateIsAccountsUpt: (state, payload) =>{
    // console.log('Entered Mutation', payload);
    state.isAccountsUpt = payload;
    },
    updateIsAccountUpt: (state, payload) =>{
    // console.log('Entered Mutation', payload);
    state.isAccountUpt = payload;
    },
    updateIsAccountsAdminUpt: (state, payload) =>{
    // console.log('Entered Mutation', payload);
    state.isAccountsAdminUpt = payload;
    },
    updateCreateCompanyLoading: (state, payload) =>{
    // console.log('Entered Mutation', payload);updateCreateAccountLoading
    state.createCompanyLoading = payload;
    },
    updateCreateAccountLoading: (state, payload) =>{
    // console.log('Entered Mutation', payload);
    state.createAccountLoading = payload;
    },
    updateResponse: (state, payload) =>{
    // console.log('Entered Mutation', payload);
    state.response = payload;
    },
    updateCompaniesLoading: (state, payload) =>{
        state.companiesLoading = payload;
    },
    updateAccountsLoading: (state, payload) =>{
        state.accountsLoading = payload;
    },
    // eslint-disable-next-line no-unused-vars
    reset: (state, payload) =>{
        state.companies =[];
        state.accounts =[];
        state.accountsAdmin =[];
        state.company ={};
        state.account ={};
        state.isCompaniesUpt = false;
        state.isAccountsUpt = false;
        state.isAccountsAdminUpt = false;
        state.companiesLoading = false;
        state.accountsLoading = false;
        state.createCompanyLoading =false;
        state.createAccountLoading =false;
        state.response ={};
    },

}


export const actions = {
    updateCompanies: ({ commit }, payload)=>{
        commit("updateCompaniesLoading", true);
            return CompanyService.callGetCompaniesApi(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateCompaniesLoading", false);
                if (responseData.responseCode === "00") {
                    commit("updateIsCompaniesUpt", true);
                    commit("updateCompanies", responseData.data);
                    if (responseData.data.length < 1){
                        //console.log(router.currentRoute.fullPath)
                        if (router.currentRoute.fullPath !== '/new-company')
                            router.push('/new-company');
                        return
                    }
                    let currCompany = localStorage.orgID == null? state.companies[0].orgID : localStorage.orgID;
                    localStorage.orgID = currCompany;
                    commit("updateCompany", currCompany);
                    //console.log("callGetCompaniesApi responseData ==>>", responseData,currCompany);
                    let currAccount = localStorage.accNumber == null? state.company[0].accounts[0].accNumber : localStorage.accNumber
                    //let currAccount = state.company[0].accounts[0].accNumber
                    localStorage.accNumber = currAccount;
                    console.log('>>>>>>>>currAccount<<<<<<<<<<',currAccount)
                    commit("updateAccount", currAccount);
                    //console.log("callGetCompaniesApi responseData ==>>", responseData,currCompany,currAccount);
                }
            })
                // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateCompaniesLoading", false)
                
                // alert(error)
                // throw error;
            });
    },

    updateCompany: ({ commit }, payload)=>{
        commit('updateCompany', payload)
    },

    updateAccounts: ({ commit }, payload)=>{
        commit("updateAccountsLoading", true)  
            return CompanyService.callGetAccountsApi(payload)
            .then(response => { 
                let responseData = response.data;
                commit("updateAccountsLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateIsAccountsUpt", true) 
                    // console.log("callupdateAccountsApi responseData ==>>", responseData);
                    commit("updateAccounts", responseData.data)
                    commit("updateAccount", localStorage.accID)
                }
            })
                // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateAccountsLoading", false)
                // alert(error)
            });
    },

    upgradeAccount: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAccountsLoading", true)  
            return CompanyService.callUpgradeAccountApi(payload)
            .then(response => { 
                let responseData = response.data;
                commit("updateAccountsLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateIsAccountsUpt", true) 
                    // console.log("callupdateAccountsApi responseData ==>>", responseData);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Account upgrade successfully!', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
            })
                // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateAccountsLoading", false)
                // alert(error)
            });
    },

    updateAccount: ({ commit }, payload)=>{
        commit('updateAccount', payload)
    },

    updateIsUserInfoUpt: ({ commit }, payload)=>{
        commit('updateIsUserInfoUpt', payload)
    },

    updateIsCompaniesUpt: ({ commit }, payload)=>{
        commit('updateIsCompaniesUpt', payload)
    },

    updateIsAccountsUpt: ({ commit }, payload)=>{
        commit('updateIsAccountsUpt', payload)
    },

    updateIsAccountUpt: ({ commit }, payload)=>{
        commit('updateIsAccountUpt', payload)
    },

    updateIsAccountsAdminUpt: ({ commit }, payload)=>{
        commit('updateIsAccountsAdminUpt', payload)
    },

    updateAccountsAdmin: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateAccountsLoading", true) 
            return CompanyService.callGetAccountsApi(payload)
            .then(response => {
                let responseData = response.data;
                if (responseData.responseCode === "00") {
                    commit("updateAccountsLoading", false)
                    commit("updateIsAccountsAdminUpt", true)
                    let responseData = response.data;
                    commit("updateAccountsAdmin", responseData.data)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else {
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
                // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateAccountsLoading", false)
            });
    },

    createCompany: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateResponse", {})
        commit("updateCreateCompanyLoading", true)  
            return CompanyService.callCreateCompanyApi(payload)
            .then(response => {
                commit("updateCreateCompanyLoading", false)
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateCreateCompanyLoading", false)
                    commit("updateResponse", responseData)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        .then(res => {
                            //console.log(res); // {ok: true|false|undefined}
                            if (res.ok)
                                window.location = '/dashboard'
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
                // eslint-disable-next-line no-unused-vars
            .catch(error => {
                commit("updateCreateCompanyLoading", false)
                // alert(error)
            });
    },
    
    createAccount: ({ commit, dispatch }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateResponse", {})
        commit("updateCreateAccountLoading", true)
            return CompanyService.callCreateAccountApi(payload)
            .then(response => {
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateCreateAccountLoading", false)
                    // console.log("callGetCompaniesApi responseData ==>>", responseData);
                    commit("updateResponse", responseData)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Account Created Successfully!', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            dispatch("updateCompanies", {
                                userID: store.state.system.userInfo.id,
                                requestType: 'company'
                            }, { root: false });
                        });

                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }

            })
            .catch(error => {
                commit("updateCreateAccountLoading", false)
                alert(error)
            });
    },

    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
